import { store } from "@betacrew/jars-flux";
import { all, put, takeLatest } from "redux-saga/effects";
import { componentKey, setLoadingState, setPayersList, setPayersPaginationState, setSelectedPayer } from "./PayerDropdownSlice";
import PayerDataService from "../../../../services/PayerDataService";
import { addNotifications } from "../../toaster/ToasterPortalSlice";
import Payer from "../../../../libs/utility/Payer";
import { PAYER_DROPDOWN_LOADING_STATES } from "./constants";
import General from "../../../../libs/utility/General";

export const { getPaginatedPayersList } = {
    getPaginatedPayersList: (payload) => {
        return {
            type: "PAYER_DROPDOWN/GET_PAGINATED_PAYERS_LIST",
            payload
        }
    },
}

function* getPaginatedPayersListAsync(action) {

    try {
        yield put(setLoadingState({ state: PAYER_DROPDOWN_LOADING_STATES.GET_PAGINATED_PAYER_LIST_LOADING }))

        const { PageNumber, PageSize, FilterText, IsDesc, IdNumber, defaultPayer, selectedPayer } = action.payload;

        const params = {
            PageNumber: PageNumber || 1,
            PageSize: PageSize || 10,
            FilterText: FilterText || "",
            IdNumber: IdNumber || "",
            IsDesc: IsDesc || false,
        }

        const response = yield PayerDataService.getPayersList(params);

        const { Message, Status } = response?.data;
        const Data = General.extractDataFromResponseData(response?.data)

        if (Status) {

            Data.map(item => {
                let label = `${item?.FirstName || ''} ${item?.LastName || ''} ${item.IdNumber && `| TAX ID - ${item.IdNumber || ''}`}`

                item.label = label.trimStart();
                item.value = item["PayerDetailId"];
            })

            yield put(setPayersList(Data));

            if (Data.length && !selectedPayer?.PayerDetailId) {
                yield put(setSelectedPayer(Data[0]))
            }

            if (Data.length && defaultPayer?.PayerDetailId) {
                const payer = Data.find(p => p?.PayerDetailId == defaultPayer?.PayerDetailId);

                if (payer) {
                    yield put(setSelectedPayer(payer))
                }
            }

            yield put(setPayersPaginationState({ ...action.payload, totalPayers: General.extractPaginationTotalFromResponse(response.data) }))

        } else {
            yield put(addNotifications({ heading: "Error", message: Message }));
        }

    } catch (error) {
        console.log('err: ', error)
        yield put(addNotifications({ heading: "Failed to get the payers list", message: error?.response?.data?.Message }));
    } finally {
        yield put(setLoadingState({ state: PAYER_DROPDOWN_LOADING_STATES.GET_PAGINATED_PAYER_LIST_READY  }))
    }

}

function* rootSaga() {
    yield all([
        takeLatest(getPaginatedPayersList().type, getPaginatedPayersListAsync),
    ]);
}

store.sagaManager.addSaga(componentKey, rootSaga);